import { motion } from "framer-motion";
import "../../styles/AnimationGallery.css";

const images = [
  {
    src: "/assets/gallery/galleryimage1.png",
    className: "pos-top-left",
    delay: 0.2,
    height: "10rem",
  },
  {
    src: "/assets/gallery/galleryimage2.png",
    className: "pos-top-center",
    delay: 0.4,
    height: "10rem",
  },
  {
    src: "/assets/gallery/galleryimage3.png",
    className: "pos-top-right",
    delay: 0.6,
  },
  {
    src: "/assets/gallery/galleryimage4.png",
    className: "pos-mid-left",
    delay: 0.8,
    height: "18rem",
  },
  {
    src: "/assets/gallery/galleryimage5.png",
    className: "pos-mid-right",
    delay: 1.0,
  },
  {
    src: "/assets/gallery/galleryimage6.png",
    className: "pos-bottom-left",
    delay: 1.2,
  },
  {
    src: "/assets/gallery/galleryimage7.png",
    className: "pos-bottom-right",
    delay: 1.4,
  },
];

const imageVariants = {
  hidden: { y: 100, opacity: 0, scale: 0.9 },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: { duration: 1.2, ease: "easeOut" },
  },
  hover: {
    scale: 1.05,
    y: -5,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
};

const AnimationGallery = () => {
  return (
    <div className="gallery-container">
      {/* Center Text */}
      <div className="gallery-center-text-container d-none d-md-flex">
        <h1 className="wise-secondary-gradient main-title">
          QUICK JOURNEY <br />
          <span className="highlight">WISE 2025</span>
        </h1>
        <p className="text-secondary subtitle">
          Women in semiconductor <br /> 2025. Quick journey
        </p>
      </div>

      <div className="images-container d-none d-md-block">
        {images.map((item, i) => (
          <motion.div
            key={i}
            className={`gallery-image-wrapper ${item.className}`}
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            whileHover="hover"
            transition={{ delay: item.delay }}
          >
            <img
              src={item.src}
              alt={`Gallery ${i}`}
              className="gallery-image"
              style={{ height: item.height, width: "auto" }}
            />
          </motion.div>
        ))}
      </div>

      {/* Mobile Balanced Layout (6 images only) */}
      <div className="mobile-gallery d-md-none">
        {/* Top row (2 images) */}
        <div className="mobile-row">
          <motion.img
            src={images[0].src}
            alt="Top left"
            className="mobile-gallery-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: images[0].delay }}
          />
          <motion.img
            src={images[1].src}
            alt="Top right"
            className="mobile-gallery-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: images[1].delay }}
          />
        </div>

        {/* Middle row: left - text - right */}
        <div className="mobile-row center-row">
          <motion.img
            src={images[2].src}
            alt="Mid left"
            className="mobile-gallery-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: images[2].delay }}
          />

          <div className="gallery-center-text-mobile">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="main-title"
            >
              QUICK JOURNEY <br />
              <span className="highlight">WISE 2025</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
              className="subtitle"
            >
              Women in semiconductor <br /> 2025. Quick journey
            </motion.p>
          </div>

          <motion.img
            src={images[3].src}
            alt="Mid right"
            className="mobile-gallery-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: images[3].delay }}
          />
        </div>

        {/* Bottom row (2 images) */}
        <div className="mobile-row">
          <motion.img
            src={images[4].src}
            alt="Bottom left"
            className="mobile-gallery-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: images[4].delay }}
          />
          <motion.img
            src={images[5].src}
            alt="Bottom right"
            className="mobile-gallery-image"
            variants={imageVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: images[5].delay }}
          />
        </div>
      </div>
    </div>
  );
};

export default AnimationGallery;
